import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/forms/edit_specifications_area_wizard/EditSpecificationsAreaForm.scss';
import Button from '../../components/Button';
import { __, getLocalized, setTableParams } from '../../core/utils';
import ArrowRightMiddleIcon from '../../assets/images/arrow-right-middle-15x15.svg';
import ArrowDownSmallIcon from '../../assets/images/arrow-down-small-15x15.svg';
import { withRouter } from 'react-router';
import Dropdown from '../../components/Dropdown';
import RoomChooser from '../../components/RoomChooser';
import { hideDropdown } from '../../redux/actions/general/dropdown';
import Tooltip from '../../components/Tooltip';
import classNames from 'classnames';
import * as _ from 'lodash';

@withRouter
class EditSpecificationsAreaForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      area: null,
      expanded_all: false,
      submitting: false,
    };
  }

  _handleSubmit = (e) => {
    e.preventDefault();

    if (!this.state.area || this.state.submitting) {
      return;
    }

    const promise = this.props.onSubmit({ area: this.state.area });

    if (promise && promise.then) {
      this.setState({ submitting: true });
      promise.finally(() => this.setState({ submitting: false }));
    }
  };

  _handleAreaChange = (area) => {
    this.setState({ area });
    hideDropdown();
  };

  _buildSpaceAllocation() {
    const { languageId, spaceAllocationData } = this.props;
    const space_allocation = [];

    _.each(spaceAllocationData.sites, (site) =>
      space_allocation.push({
        id: site.id,
        type: 'site',
        display_name: site.code + ': ' + getLocalized(site.title, languageId),
        parent_type: null,
        parent_id: null,
      })
    );

    _.each(spaceAllocationData.buildings, (building) =>
      space_allocation.push({
        id: building.id,
        type: 'building',
        display_name:
          building.code + ': ' + getLocalized(building.title, languageId),
        parent_type: building.site_id ? 'site' : null,
        parent_id: building.site_id ? building.site_id : null,
      })
    );

    _.each(spaceAllocationData.storeys, (storey) =>
      space_allocation.push({
        id: storey.id,
        type: 'storey',
        display_name:
          storey.number + ': ' + getLocalized(storey.name, languageId),
        parent_type: storey.building_id ? 'building' : null,
        parent_id: storey.building_id ? storey.building_id : null,
      })
    );

    _.each(spaceAllocationData.rooms, (room) => {
      const find_room_type = _.find(spaceAllocationData.room_types, [
        'id',
        room.room_type_id,
      ]);

      space_allocation.push({
        id: room.id,
        type: 'room',
        display_name: (
          <Tooltip
            text={
              find_room_type
                ? `${getLocalized(find_room_type?.title, languageId)} (${_.size(
                    _.filter(spaceAllocationData.rooms, [
                      'room_type_id',
                      find_room_type?.id,
                    ])
                  )})`
                : room.code + ': ' + getLocalized(room.name, languageId)
            }
          >
            {room.code + ': ' + getLocalized(room.name, languageId)}
          </Tooltip>
        ),
        parent_type: room.storey_id ? 'storey' : null,
        parent_id: room.storey_id ? room.storey_id : null,
        room_type_id: room.room_type_id,
      });
    });

    _.each(spaceAllocationData.room_types, (room_type) => {
      space_allocation.push({
        id: room_type.id,
        type: 'room_type',
        display_name: `${getLocalized(room_type.title, languageId)} (${_.size(
          _.filter(spaceAllocationData.rooms, ['room_type_id', room_type?.id])
        )})`,
      });
    });

    return space_allocation;
  }

  render() {
    const { area, expanded_all, submitting } = this.state;
    const space_allocation = this._buildSpaceAllocation();

    return (
      <form onSubmit={this._handleSubmit} className={styles.wrapper}>
        <div className={styles.form}>
          <Dropdown
            top={25}
            leftStyled
            wrapperClassName={styles.dropdownWrapper}
            name='edit-specifications-area.area'
            header={
              <div className={styles.dropdownHeader}>
                {__('table.area-tab.area')}

                <div className={styles.dropdownHeaderActions}>
                  <span
                    className={styles.dropdownHeaderExpandAll}
                    onClick={() =>
                      this.setState({ expanded_all: !expanded_all })
                    }
                  >
                    {__('boq-flyout.area.expand-all')}
                  </span>
                  <span
                    className={styles.dropdownHeaderClear}
                    onClick={() => {
                      this.setState({ area: null });
                      hideDropdown();
                    }}
                  >
                    {__('boq-flyout.area.clear')}
                  </span>
                </div>
              </div>
            }
            content={
              <div className={classNames(styles.dropdownContent, styles.space)}>
                <RoomChooser
                  onCancel={hideDropdown}
                  options={space_allocation}
                  onDone={this._handleAreaChange}
                  initialValues={area ? [area] : []}
                  expandedAllNodes={expanded_all}
                />
              </div>
            }
          >
            <div className={classNames(styles.dropdown, styles.areaDropdown)}>
              {area ? (
                <Tooltip text={area.display_name}>
                  <span>{area.display_name}</span>
                </Tooltip>
              ) : (
                <span className={styles.none}>
                  {__('boq-flyout.select-area')}
                </span>
              )}{' '}
              <ArrowDownSmallIcon />
            </div>
          </Dropdown>
        </div>
        <div className={styles.footer}>
          <Button
            lightGray
            medium
            left
            middleText={__('button.cancel')}
            onClick={() =>
              setTableParams('specification_sets', {
                edit_specifications_area_wizard: undefined,
              })
            }
          />
          <Button
            gray
            medium
            submit
            right
            leftText={__('button.create')}
            rightIcon={ArrowRightMiddleIcon}
            spinning={submitting}
            disabled={!area}
          />
        </div>
      </form>
    );
  }
}

export default EditSpecificationsAreaForm;
